import { Settings2 } from "lucide-react";
import { fmtEur, fmtHours, RATE_SOURCE } from "@/lib/reports";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";

const KIND = { manodopera: "Manodopera", trasferta: "Trasferta", materiale: "Materiale", servizio: "Servizio" };
const R = ({ l, v, strong, testId }) => <div className={`flex justify-between py-1 text-sm ${strong ? "font-semibold text-ink" : "text-slate-600"}`} data-testid={testId}><span>{l}</span><span>{v}</span></div>;

export const ChargePanel = ({ rep, preview, onRate }) => {
  const c = rep.charge || (preview && !preview.error ? preview : null);
  return (
    <Panel className="p-5" data-testid="report-charge">
      <div className="flex items-center justify-between"><SectionLabel>{rep.charge ? "Consuntivo confermato" : "Anteprima consuntivo"}</SectionLabel>
        {rep.can.rate && <Button size="sm" variant="outline" className="gap-1" onClick={onRate} data-testid="report-rate-button"><Settings2 className="h-4 w-4" />Tariffa / prezzi</Button>}</div>
      {!c && <p className="mt-2 text-sm text-amber-700" role="alert" data-testid="report-preview-error">{preview?.error || "Calcolo non disponibile."}</p>}
      {c && <>
        <p className="mt-1 text-xs text-slate-500" data-testid="report-rate-source">{RATE_SOURCE[c.rate?.source]} · {fmtEur(c.rate?.hourly_rate)}/h{c.rate?.travel_rate != null ? ` · trasferta ${fmtEur(c.rate.travel_rate)}` : ""}</p>
        <ul className="mt-3 divide-y divide-line/60">{c.lines.map((l, i) => (
          <li key={i} className="flex justify-between gap-3 py-1.5 text-sm" data-testid={`report-charge-line-${i}`}>
            <span className="min-w-0 text-slate-700"><span className="text-xs font-semibold uppercase text-slate-400">{KIND[l.kind]}</span> {l.kind === "manodopera" ? `${fmtHours(l.minutes / 60)}` : `${l.description} · ${l.quantity} ${l.unit}`} × {fmtEur(l.unit_price)}</span>
            <span className="shrink-0 font-medium text-ink">{fmtEur(l.net)}</span></li>))}
        </ul>
        <div className="mt-3 border-t border-line pt-2">
          <R l="Imponibile" v={fmtEur(c.taxable)} strong testId="report-charge-taxable" /><R l="IVA" v={fmtEur(c.vat)} /><R l="Totale" v={fmtEur(c.total)} testId="report-charge-total" />
          {rep.charge && <>
            <R l={`Coperto da pacchetto${c.package_number ? ` ${c.package_number}` : ""}`} v={`− ${fmtEur(c.package_covered_net)}${c.package_covered_hours ? ` · ${fmtHours(c.package_covered_hours)}` : ""}`} testId="report-charge-covered" />
            <R l="Da fatturare (imponibile)" v={fmtEur(c.to_invoice_net)} strong testId="report-charge-to-invoice" />
            <R l="Da fatturare (IVA inclusa)" v={fmtEur(c.to_invoice_total)} />
          </>}
        </div>
      </>}
    </Panel>
  );
};
